(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("actionsheet", [], factory);
	else if(typeof exports === 'object')
		exports["actionsheet"] = factory();
	else
		root["actionsheet"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 